import { BasicList, CenteredLoader, Flex, Text } from "@shared/primitive-components"
import { NoDataMessage } from "@shared/primitive-components/src/Table/components/NoDataMessage"
import { localDateTimeToString } from "@shared/utils/formatters/dates"
import { InsightsPeriod, PeriodVehicle } from "../../../../api/insights/periods/types"
import { worstSpeedersStyles as styles } from "../../../styles"
import { WorstSpeederItem } from "."

type Props = {
  data: ReadonlyArray<PeriodVehicle>
  activePeriod: InsightsPeriod | null
  loading?: boolean
}

export const WorstSpeedersList = ({ data, activePeriod, loading }: Props) => (
  <>
    {loading ? (
      <CenteredLoader height="156px" />
    ) : activePeriod && data.length ? (
      <Flex flexDirection="column">
        <Text use="body2" css={styles.periodDate}>
          {localDateTimeToString(activePeriod.startedAt, `en`, `dd MMM yyyy`)} -{` `}
          {localDateTimeToString(activePeriod.endedAt, `en`, `dd MMM yyyy`)}
        </Text>
        <BasicList css={styles.list}>
          {data.map((item: PeriodVehicle, index) => (
            <WorstSpeederItem item={item} index={index + 1} key={item.vrn} />
          ))}
        </BasicList>
      </Flex>
    ) : (
      <NoDataMessage />
    )}
  </>
)

WorstSpeedersList.defaultProps = {
  loading: undefined,
}
